/**
 * @file utils/browser.js 浏览器相关工具类
 * @author zhangzhe(zhangzhe@baidu.com)
 */

export function isBrowser(): boolean {
    return typeof window !== 'undefined';
}

export function isAbsolutePath(path: string): boolean {
    return /^https?:\/\//.test(path);
}

export function isScrollBottom(): boolean {
    const scrollTop = window.pageYOffset
        || (document.documentElement && document.documentElement.scrollTop)
        || (document.body && document.body.scrollTop)
        || 0; // 滚动距离
    const clientHeight = (document.documentElement && document.documentElement.clientHeight)
        || (document.body && document.body.clientHeight)
        || 0; // 展示高度
    const scrollHeight = Math.max(
        (document.documentElement ? document.documentElement.scrollHeight : 0),
        (document.body ? document.body.scrollHeight : 0),
        0
    ); // 文档总高度
    return scrollHeight - scrollTop - clientHeight < 10;
}

export function getQueryString(name: string, search: string) {
    const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
    const res = search.substr(1).match(reg);
    return res !== null ? decodeURIComponent(res[2]) : '';
}
